(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["CLAUDE-BOTON"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar() {
    var boton = document.querySelector('[data-cft-boton]');
    if (!boton) return;
    /* Lo saca de su sección y lo pone directo en la página, así ninguna imagen lo tapa */
    /* Si la sección está puesta dos veces, deja solo un botón */
    var otros = document.querySelectorAll('[data-cft-boton]');
    for (var i = 1; i < otros.length; i++) otros[i].remove();
    if (boton.parentNode !== document.body) document.body.appendChild(boton);
    function luz(rgb) {
      var n = (rgb || '').match(/\d+/g);
      if (!n) return 255;
      return 0.299 * n[0] + 0.587 * n[1] + 0.114 * n[2];
    }
    function revisar() {
      var footer = document.querySelector('.ftn-footer') || document.querySelector('footer');
      if (!footer) return;
      var f = footer.getBoundingClientRect();
      var b = boton.getBoundingClientRect();
      var encima = f.top < b.bottom && f.bottom > b.top;
      boton.setAttribute('data-cft-sobre-oscuro', encima && luz(getComputedStyle(footer).backgroundColor) < 128 ? 'true' : 'false');
    }
    revisar();
    window.addEventListener('scroll', revisar, { passive: true });
    window.addEventListener('resize', revisar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["CLAUDE-CARRUSEL"] && !Shopify.designMode) return;
  try {
    
(function () {
  function sprInit() {
    document.querySelectorAll('.spr-seccion').forEach(function (seccion) {
      var lista = seccion.querySelector('[data-spr-lista]');
      var flechaAnterior = seccion.querySelector('[data-spr-anterior]');
      var flechaSiguiente = seccion.querySelector('[data-spr-siguiente]');
      if (!lista) {
        return;
      }

      function anchoDesplazamiento() {
        return lista.clientWidth;
      }

      if (flechaAnterior) {
        flechaAnterior.addEventListener('click', function () {
          lista.scrollBy({ left: -anchoDesplazamiento(), behavior: 'smooth' });
        });
      }
      if (flechaSiguiente) {
        flechaSiguiente.addEventListener('click', function () {
          lista.scrollBy({ left: anchoDesplazamiento(), behavior: 'smooth' });
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sprInit);
  } else {
    sprInit();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["CLAUDE-HOMBRE-MUJER"] && !Shopify.designMode) return;
  try {
    
(function () {
  function hltInit() {
    var secciones = document.querySelectorAll('.hlt-seccion');
    secciones.forEach(function (seccion) {
      var pestanas = seccion.querySelectorAll('[data-hlt-pestana]');
      var tarjetas = seccion.querySelectorAll('[data-hlt-tarjeta]');

      pestanas.forEach(function (pestana) {
        pestana.addEventListener('click', function () {
          var grupo = pestana.getAttribute('data-grupo');

          pestanas.forEach(function (p) {
            p.classList.remove('hlt-pestana-activa');
          });
          pestana.classList.add('hlt-pestana-activa');

          tarjetas.forEach(function (tarjeta) {
            if (tarjeta.getAttribute('data-grupo') === grupo) {
              tarjeta.classList.remove('hlt-oculta');
            } else {
              tarjeta.classList.add('hlt-oculta');
            }
          });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hltInit);
  } else {
    hltInit();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["CLAUDE-VISTO-RECIENTEMENTE"] && !Shopify.designMode) return;
  try {
    
(function () {
  function vrpInit() {
    var lista = document.querySelector('[data-vrp-lista]');
    if (!lista) {
      return;
    }

    lista.addEventListener('click', function (evento) {
      var boton = evento.target.closest('[data-vrp-favorito]');
      if (boton) {
        var activo = boton.getAttribute('data-activo') === 'true';
        boton.setAttribute('data-activo', activo ? 'false' : 'true');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vrpInit);
  } else {
    vrpInit();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
(function () {
  function ftnInit() {
    var botones = document.querySelectorAll('[data-ftn-toggle-columna]');

    botones.forEach(function (boton) {
      boton.addEventListener('click', function () {
        var columna = boton.closest('[data-ftn-columna]');
        if (!columna) {
          return;
        }
        var abierta = columna.getAttribute('data-abierta') === 'true';
        columna.setAttribute('data-abierta', abierta ? 'false' : 'true');
        boton.setAttribute('aria-expanded', abierta ? 'false' : 'true');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ftnInit);
  } else {
    ftnInit();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var CLAVE_WISHLIST = 'bt_wishlist';

  function actualizarWishlist() {
    var contador = document.querySelector('[data-ndr-contador-wishlist]');
    if (!contador) return;
    var lista = [];
    try {
      lista = JSON.parse(localStorage.getItem(CLAVE_WISHLIST)) || [];
    } catch (e) {
      lista = [];
    }
    contador.textContent = lista.length;
    contador.hidden = lista.length === 0;
  }

  function actualizarCarrito() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('carrito');
        return r.json();
      })
      .then(function (carrito) {
        var contador = document.querySelector('[data-ndr-contador-carrito]');
        if (!contador) return;
        contador.textContent = carrito.item_count;
        contador.hidden = carrito.item_count === 0;
      })
      .catch(function () {});
  }

  function init() {
    var header = document.querySelector('[data-ndr-header]');
    if (!header) return;

    actualizarWishlist();
    window.addEventListener('storage', actualizarWishlist);
    document.addEventListener('wishlist:refresh', actualizarWishlist);
    document.addEventListener('cart:refresh', actualizarCarrito);

    /* Mide la altura real del header para que la imagen suba exactamente debajo */
    var contenedor = header.closest('.shopify-section');

    function medirAlto() {
      if (!contenedor) return;
      contenedor.style.setProperty('--ndr-alto-real', header.offsetHeight + 'px');
    }

    medirAlto();
    window.addEventListener('resize', medirAlto);
    window.addEventListener('load', medirAlto);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(medirAlto);
    if ('ResizeObserver' in window) new ResizeObserver(medirAlto).observe(header);

    /* Menú móvil */
    var fondo = header.querySelector('[data-ndr-fondo-menu]');
    var panel = header.querySelector('[data-ndr-panel-menu]');

    function abrirMenu() {
      fondo.setAttribute('data-abierto', 'true');
      panel.setAttribute('data-abierto', 'true');
      panel.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }

    function cerrarMenu() {
      fondo.setAttribute('data-abierto', 'false');
      panel.setAttribute('data-abierto', 'false');
      panel.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    var btnAbrir = header.querySelector('[data-ndr-abrir-menu]');
    var btnCerrar = header.querySelector('[data-ndr-cerrar-menu]');
    if (btnAbrir) btnAbrir.addEventListener('click', abrirMenu);
    if (btnCerrar) btnCerrar.addEventListener('click', cerrarMenu);
    if (fondo) fondo.addEventListener('click', cerrarMenu);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') cerrarMenu();
    });

    /* Acordeón del menú celular: se abre una sección a la vez */
    var filas = header.querySelectorAll('[data-ndr-acordeon]');
    filas.forEach(function (fila) {
      fila.addEventListener('click', function () {
        var abrir = fila.getAttribute('aria-expanded') !== 'true';
        filas.forEach(function (otra) {
          otra.setAttribute('aria-expanded', 'false');
          var s = document.getElementById(otra.getAttribute('aria-controls'));
          if (s) s.setAttribute('data-abierto', 'false');
        });
        if (abrir) {
          fila.setAttribute('aria-expanded', 'true');
          var sub = document.getElementById(fila.getAttribute('aria-controls'));
          if (sub) sub.setAttribute('data-abierto', 'true');
        }
      });
    });

    /* Mega menú de escritorio: un panel con todo el menú */
    var nav = header.querySelector('[data-ndr-nav]');
    var mega = header.querySelector('[data-ndr-mega]');
    var items = header.querySelectorAll('[data-ndr-mega-item]');
    var fondoMega = header.querySelector('[data-ndr-mega-fondo]');
    var escritorio = window.matchMedia('(min-width: 990px)');
    var esTactil = window.matchMedia('(hover: none)').matches;
    var temporizador = null;

    function marcar(item) {
      var g = item ? item.getAttribute('data-grupo') : null;
      items.forEach(function (it) {
        var activo = it === item;
        it.classList.toggle('ndr-nav-item--activo', activo);
        var a = it.querySelector('.ndr-nav-enlace');
        if (a && a.hasAttribute('aria-expanded')) a.setAttribute('aria-expanded', activo ? 'true' : 'false');
      });
      if (!mega) return;
      mega.querySelectorAll('[data-grupo]').forEach(function (el) {
        el.classList.toggle('es-activo', g !== null && el.getAttribute('data-grupo') === g);
      });
    }

    function cerrarMega() {
      clearTimeout(temporizador);
      if (nav) nav.classList.remove('ndr-mega-abierto');
      header.classList.remove('ndr-header--mega');
      marcar(null);
      if (fondoMega) fondoMega.setAttribute('data-abierto', 'false');
    }

    function abrirMega(item) {
      if (!mega || !escritorio.matches) return;
      clearTimeout(temporizador);
      nav.classList.add('ndr-mega-abierto');
      header.classList.add('ndr-header--mega');
      marcar(item);
      if (fondoMega) {
        fondoMega.style.top = Math.max(0, header.getBoundingClientRect().bottom) + 'px';
        fondoMega.setAttribute('data-abierto', 'true');
      }
    }

    function cerrarConPausa() {
      clearTimeout(temporizador);
      temporizador = setTimeout(cerrarMega, 200);
    }

    if (nav && mega) {
      items.forEach(function (item) {
        if (!esTactil) item.addEventListener('mouseenter', function () { abrirMega(item); });
        var enlace = item.querySelector('.ndr-nav-enlace');
        /* En pantallas táctiles: el primer toque abre el panel, el segundo entra */
        if (enlace) {
          enlace.addEventListener('click', function (e) {
            if (esTactil && escritorio.matches && !item.classList.contains('ndr-nav-item--activo')) {
              e.preventDefault();
              abrirMega(item);
            }
          });
        }
      });
      if (!esTactil) {
        mega.addEventListener('mouseenter', function () { clearTimeout(temporizador); });
        nav.addEventListener('mouseleave', cerrarConPausa);
      }
      nav.addEventListener('focusin', function (e) {
        var li = e.target.closest('[data-ndr-mega-item]');
        abrirMega(li || null);
      });
      nav.addEventListener('focusout', function (e) {
        if (!nav.contains(e.relatedTarget)) cerrarConPausa();
      });
    }

    if (fondoMega) {
      fondoMega.addEventListener('click', cerrarMega);
      fondoMega.addEventListener('mouseenter', cerrarConPausa);
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') cerrarMega();
    });
    window.addEventListener('scroll', function () {
      if (header.classList.contains('ndr-header--mega')) cerrarMega();
    }, { passive: true });
    if (escritorio.addEventListener) escritorio.addEventListener('change', cerrarMega);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  function mpvInit() {
    var contenedor = document.querySelector('.mpv-seccion');
    if (!contenedor) {
      return;
    }

    var headerSitio = document.querySelector('[data-ndr-header]');
    var galeriaParaHeader = contenedor.querySelector('.mpv-galeria-contenedor');

    function actualizarDivisionHeader() {
      if (!headerSitio || !galeriaParaHeader) {
        return;
      }
      var esDesktop = window.matchMedia('(min-width: 990px)').matches;
      if (!esDesktop) {
        headerSitio.style.background = '';
        return;
      }
      var bordeDerecho = galeriaParaHeader.getBoundingClientRect().right;
      headerSitio.style.background =
        'linear-gradient(to right, #f2f1f0 ' + bordeDerecho + 'px, #ffffff ' + bordeDerecho + 'px)';
    }

    actualizarDivisionHeader();
    window.addEventListener('resize', actualizarDivisionHeader);

    var datosScript = contenedor.querySelector('[data-mpv-datos-variantes]');
    var variantes = [];
    try {
      variantes = JSON.parse(datosScript.textContent);
    } catch (error) {
      variantes = [];
    }

    var datosInventarioScript = contenedor.querySelector('[data-mpv-inventario-variantes]');
    var inventarioPorVariante = {};
    try {
      inventarioPorVariante = JSON.parse(datosInventarioScript.textContent);
    } catch (error) {
      inventarioPorVariante = {};
    }

    var inputVariante = contenedor.querySelector('[data-mpv-input-variante]');
    var precioElemento = contenedor.querySelector('[data-mpv-precio]');
    var precioContenedor = contenedor.querySelector('[data-mpv-precio-contenedor]');
    var precioComparacionElemento = contenedor.querySelector('[data-mpv-precio-comparacion]');
    var botonAgregarCarrito = contenedor.querySelector('[data-mpv-agregar-carrito]');
    var textoAgregarCarritoSpan = contenedor.querySelector('[data-mpv-texto-agregar]');
    var botonComprarAhora = contenedor.querySelector('[data-mpv-comprar-ahora]');
    var textoComprarAhoraSpan = contenedor.querySelector('[data-mpv-texto-comprar-ahora]');
    var nombreColorElemento = contenedor.querySelector('[data-mpv-color-nombre]');
    var gruposOpcion = contenedor.querySelectorAll('[data-mpv-opcion]');
    var imagenGaleriaPrincipal = contenedor.querySelector('[data-mpv-imagen-galeria]');
    var selectorCantidad = contenedor.querySelector('[data-mpv-selector-cantidad]');
    var selectorCantidadContenedor = contenedor.querySelector('.mpv-selector-cantidad-contenedor');
    var grupoTallaElemento = contenedor.querySelector('.mpv-grupo-talla');
    var cantidadOpcionesTalla = grupoTallaElemento
      ? grupoTallaElemento.querySelectorAll('[data-mpv-valor]').length
      : 0;
    var tallaSeleccionada = !grupoTallaElemento || cantidadOpcionesTalla <= 1;
    var textoSeleccionarTalla = botonAgregarCarrito
      ? botonAgregarCarrito.getAttribute('data-texto-seleccionar-talla') || 'Selecciona una talla'
      : 'Selecciona una talla';

    function generarOpcionesCantidad(variante) {
      if (!selectorCantidad) {
        return;
      }
      var maxCantidad = 10;
      if (variante) {
        var inventarioReal = inventarioPorVariante[String(variante.id)];
        if (
          variante.inventory_management &&
          typeof inventarioReal === 'number' &&
          inventarioReal >= 1
        ) {
          maxCantidad = Math.min(inventarioReal, 20);
        }
      }
      var valorPrevio = selectorCantidad.value;
      selectorCantidad.innerHTML = '';
      for (var i = 1; i <= maxCantidad; i++) {
        var opcion = document.createElement('option');
        opcion.value = i;
        opcion.textContent = i;
        selectorCantidad.appendChild(opcion);
      }
      if (valorPrevio && parseInt(valorPrevio, 10) <= maxCantidad) {
        selectorCantidad.value = valorPrevio;
      }
      selectorCantidad.disabled = false;
    }

    function obtenerSeleccionActual() {
      var seleccion = [];
      gruposOpcion.forEach(function (grupo) {
        var posicion = parseInt(grupo.getAttribute('data-posicion'), 10);
        var activo = grupo.querySelector('.mpv-valor-activo, .mpv-swatch-activo');
        seleccion[posicion - 1] = activo ? activo.getAttribute('data-valor') : null;
      });
      return seleccion;
    }

    function encontrarVariante(seleccion) {
      return variantes.find(function (variante) {
        return seleccion.every(function (valor, indice) {
          var clave = 'option' + (indice + 1);
          return valor === null || valor === undefined || variante[clave] === valor;
        });
      });
    }

    function formatearPrecio(centavos) {
      var valor = (centavos / 100).toFixed(2);
      return 'S/. ' + valor;
    }

    function actualizarPrecioComparacion(variante) {
      if (!precioContenedor) {
        return;
      }
      var tieneComparacion =
        variante.compare_at_price && variante.compare_at_price > variante.price;

      if (tieneComparacion) {
        if (!precioComparacionElemento) {
          precioComparacionElemento = document.createElement('p');
          precioComparacionElemento.className = 'mpv-precio-comparacion';
          precioComparacionElemento.setAttribute('data-mpv-precio-comparacion', '');
          precioContenedor.appendChild(precioComparacionElemento);
        }
        precioComparacionElemento.textContent = formatearPrecio(variante.compare_at_price);
        precioComparacionElemento.hidden = false;
      } else if (precioComparacionElemento) {
        precioComparacionElemento.hidden = true;
      }
    }

    function actualizarInterfaz(variante) {
      if (!variante) {
        return;
      }
      if (inputVariante) {
        inputVariante.value = variante.id;
      }
      if (precioElemento && variante.price !== undefined) {
        precioElemento.textContent = formatearPrecio(variante.price);
      }
      actualizarPrecioComparacion(variante);
      if (botonAgregarCarrito) {
        botonAgregarCarrito.disabled = !tallaSeleccionada || !variante.available;
      }
      if (textoAgregarCarritoSpan) {
        if (!tallaSeleccionada) {
          textoAgregarCarritoSpan.textContent = textoSeleccionarTalla;
        } else {
          textoAgregarCarritoSpan.textContent = variante.available
            ? botonAgregarCarrito.getAttribute('data-texto-disponible') || textoAgregarCarritoSpan.textContent
            : botonAgregarCarrito.getAttribute('data-texto-agotado') || textoAgregarCarritoSpan.textContent;
        }
      }
      if (botonComprarAhora) {
        botonComprarAhora.disabled = !variante.available;
      }
      if (textoComprarAhoraSpan) {
        textoComprarAhoraSpan.textContent = variante.available
          ? botonComprarAhora.getAttribute('data-texto-disponible') || textoComprarAhoraSpan.textContent
          : botonComprarAhora.getAttribute('data-texto-agotado') || textoComprarAhoraSpan.textContent;
      }
      if (tallaSeleccionada) {
        generarOpcionesCantidad(variante);
      }
    }

    if (tallaSeleccionada) {
      var varianteInicial = encontrarVariante(obtenerSeleccionActual());
      generarOpcionesCantidad(varianteInicial);
    }

    gruposOpcion.forEach(function (grupo) {
      var botones = grupo.querySelectorAll('[data-mpv-valor]');
      botones.forEach(function (boton) {
        boton.addEventListener('click', function () {
          if (boton.classList.contains('mpv-valor-agotado')) {
            return;
          }
          botones.forEach(function (b) {
            b.classList.remove('mpv-valor-activo', 'mpv-swatch-activo');
          });
          if (grupo.classList.contains('mpv-grupo-talla')) {
            tallaSeleccionada = true;
            if (selectorCantidadContenedor) {
              selectorCantidadContenedor.classList.remove('mpv-selector-cantidad-bloqueado');
            }
          }
          if (boton.classList.contains('mpv-swatch')) {
            boton.classList.add('mpv-swatch-activo');
            if (nombreColorElemento) {
              nombreColorElemento.textContent = boton.getAttribute('data-valor');
            }
            var nuevaImagen = boton.getAttribute('data-imagen');
            if (nuevaImagen && imagenGaleriaPrincipal) {
              imagenGaleriaPrincipal.src = nuevaImagen;
            }
          } else {
            boton.classList.add('mpv-valor-activo');
          }
          var seleccion = obtenerSeleccionActual();
          var variante = encontrarVariante(seleccion);
          actualizarInterfaz(variante);
        });
      });
    });

    if (botonAgregarCarrito) {
      var textoConfirmacionAgregar = botonAgregarCarrito.getAttribute('data-texto-agregado') || '✓ Agregado al carrito';

      botonAgregarCarrito.addEventListener('click', function () {
        if (botonAgregarCarrito.disabled || !inputVariante || !tallaSeleccionada) {
          return;
        }
        botonAgregarCarrito.disabled = true;
        var cantidadSeleccionada = (selectorCantidad && parseInt(selectorCantidad.value, 10)) || 1;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: inputVariante.value, quantity: cantidadSeleccionada }] })
        })
          .then(function (respuesta) {
            if (!respuesta.ok) {
              throw new Error('No se pudo agregar al carrito');
            }
            if (textoAgregarCarritoSpan) {
              textoAgregarCarritoSpan.textContent = textoConfirmacionAgregar;
            }
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            try {
              var cajonCarrito = document.querySelector('cart-drawer');
              if (cajonCarrito && typeof cajonCarrito.open === 'function') {
                cajonCarrito.open();
              }
            } catch (error) {
              // El tema no tiene cajón de carrito o usa otro componente; se omite silenciosamente.
            }
            setTimeout(function () {
              if (textoAgregarCarritoSpan) {
                textoAgregarCarritoSpan.textContent =
                  botonAgregarCarrito.getAttribute('data-texto-disponible') || textoAgregarCarritoSpan.textContent;
              }
              botonAgregarCarrito.disabled = false;
            }, 2000);
          })
          .catch(function () {
            botonAgregarCarrito.disabled = false;
          });
      });
    }

    if (botonComprarAhora) {
      var textoOriginalComprarAhora = textoComprarAhoraSpan ? textoComprarAhoraSpan.textContent : '';
      var textoProcesandoComprarAhora = botonComprarAhora.getAttribute('data-texto-procesando') || 'Procesando...';

      botonComprarAhora.addEventListener('click', function () {
        if (botonComprarAhora.disabled || !inputVariante) {
          return;
        }
        botonComprarAhora.disabled = true;
        if (textoComprarAhoraSpan) {
          textoComprarAhoraSpan.textContent = textoProcesandoComprarAhora;
        }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: inputVariante.value, quantity: 1 }] })
        })
          .then(function (respuesta) {
            if (!respuesta.ok) {
              throw new Error('No se pudo agregar al carrito');
            }
            window.location.href = '/checkout';
          })
          .catch(function () {
            botonComprarAhora.disabled = false;
            if (textoComprarAhoraSpan) {
              textoComprarAhoraSpan.textContent = textoOriginalComprarAhora;
            }
          });
      });
    }

    var botonCompartir = contenedor.querySelector('[data-mpv-compartir]');
    if (botonCompartir) {
      var textoCompartirSpan = botonCompartir.querySelector('[data-mpv-texto-compartir]');
      var textoOriginalCompartir = textoCompartirSpan ? textoCompartirSpan.textContent : '';
      var urlCompartir = botonCompartir.getAttribute('data-url');
      var tituloCompartir = botonCompartir.getAttribute('data-titulo');
      var textoCompartidoConfirmacion = botonCompartir.getAttribute('data-texto-compartido') || '¡Enlace copiado!';

      botonCompartir.addEventListener('click', function () {
        if (navigator.share) {
          navigator.share({ title: tituloCompartir, url: urlCompartir }).catch(function () {
            // El usuario canceló el share nativo; no se hace nada más.
          });
          return;
        }

        function mostrarConfirmacion() {
          if (textoCompartirSpan) {
            textoCompartirSpan.textContent = textoCompartidoConfirmacion;
            setTimeout(function () {
              textoCompartirSpan.textContent = textoOriginalCompartir;
            }, 2000);
          }
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(urlCompartir).then(mostrarConfirmacion).catch(function () {});
        } else {
          var areaTemporal = document.createElement('textarea');
          areaTemporal.value = urlCompartir;
          areaTemporal.style.position = 'fixed';
          areaTemporal.style.opacity = '0';
          document.body.appendChild(areaTemporal);
          areaTemporal.select();
          try {
            document.execCommand('copy');
            mostrarConfirmacion();
          } catch (error) {
            // No se pudo copiar automáticamente; se omite silenciosamente.
          }
          document.body.removeChild(areaTemporal);
        }
      });
    }

    var galeria = contenedor.querySelector('[data-mpv-galeria]');
    if (galeria) {
      function anchoSlideGaleria() {
        var primeraImagen = galeria.querySelector('.mpv-imagen-contenedor');
        return primeraImagen ? primeraImagen.offsetWidth : galeria.offsetWidth;
      }

      var contadorActual = contenedor.querySelector('[data-mpv-contador-actual]');

      function actualizarContador(indice) {
        if (contadorActual) {
          contadorActual.textContent = indice + 1;
        }
      }

      var barraGaleria = contenedor.querySelector('[data-mpv-galeria-barra]');
      if (barraGaleria) {
        var segmentosBarra = barraGaleria.querySelectorAll('[data-mpv-barra-segmento]');

        segmentosBarra.forEach(function (segmento) {
          segmento.addEventListener('click', function () {
            var indice = parseInt(segmento.getAttribute('data-indice'), 10) || 0;
            galeria.scrollTo({ left: indice * anchoSlideGaleria(), behavior: 'smooth' });
            segmentosBarra.forEach(function (s) {
              s.classList.remove('mpv-galeria-barra-segmento-activo');
            });
            segmento.classList.add('mpv-galeria-barra-segmento-activo');
            actualizarContador(indice);
          });
        });

        var temporizadorScrollGaleria;
        galeria.addEventListener('scroll', function () {
          clearTimeout(temporizadorScrollGaleria);
          temporizadorScrollGaleria = setTimeout(function () {
            var anchoSlide = anchoSlideGaleria();
            if (!anchoSlide) {
              return;
            }
            var indiceActual = Math.round(galeria.scrollLeft / anchoSlide);
            segmentosBarra.forEach(function (s) {
              var indiceSegmento = parseInt(s.getAttribute('data-indice'), 10);
              s.classList.toggle('mpv-galeria-barra-segmento-activo', indiceSegmento === indiceActual);
            });
            actualizarContador(indiceActual);
          }, 120);
        });
      }
    }

    var botonAbrirGuia = contenedor.querySelector('[data-mpv-abrir-guia]');
    var botonCerrarGuia = contenedor.querySelector('[data-mpv-cerrar-guia]');
    var modalGuia = contenedor.querySelector('[data-mpv-modal-guia]');
    var modalFondo = contenedor.querySelector('[data-mpv-modal-fondo]');

    function cerrarGuia() {
      if (modalGuia) modalGuia.hidden = true;
      if (modalFondo) modalFondo.hidden = true;
    }

    if (botonAbrirGuia && modalGuia && modalFondo) {
      botonAbrirGuia.addEventListener('click', function () {
        modalGuia.hidden = false;
        modalFondo.hidden = false;
      });
      botonCerrarGuia.addEventListener('click', cerrarGuia);
      modalFondo.addEventListener('click', cerrarGuia);
    }

    var listaLook = contenedor.querySelector('[data-mpv-look-lista]');
    if (listaLook) {
      var botonAnteriorLook = contenedor.querySelector('[data-mpv-look-anterior]');
      var botonSiguienteLook = contenedor.querySelector('[data-mpv-look-siguiente]');
      var primeraTarjetaLook = listaLook.querySelector('.mpv-compra-look-tarjeta');
      var anchoDesplazamiento = primeraTarjetaLook ? primeraTarjetaLook.offsetWidth + 12 : 240;

      if (botonAnteriorLook) {
        botonAnteriorLook.addEventListener('click', function () {
          listaLook.scrollBy({ left: -anchoDesplazamiento, behavior: 'smooth' });
        });
      }
      if (botonSiguienteLook) {
        botonSiguienteLook.addEventListener('click', function () {
          listaLook.scrollBy({ left: anchoDesplazamiento, behavior: 'smooth' });
        });
      }
    }

    var paginacionResenas = contenedor.querySelector('[data-mpv-resenas-paginacion]');
    if (paginacionResenas) {
      var listaResenas = contenedor.querySelector('[data-mpv-resenas-lista]');
      var itemsResenas = listaResenas
        ? listaResenas.querySelectorAll('[data-mpv-resena-item]')
        : [];
      var botonesPaginaResenas = paginacionResenas.querySelectorAll('[data-mpv-resenas-pagina]');

      function mostrarPaginaResenas(numeroPagina) {
        itemsResenas.forEach(function (item) {
          var paginaItem = item.getAttribute('data-mpv-resena-pagina');
          item.hidden = paginaItem !== String(numeroPagina);
        });
        botonesPaginaResenas.forEach(function (boton) {
          var esActivo = boton.getAttribute('data-mpv-resenas-pagina') === String(numeroPagina);
          boton.classList.toggle('mpv-resenas-pagina-activa', esActivo);
        });
      }

      botonesPaginaResenas.forEach(function (boton) {
        boton.addEventListener('click', function () {
          var numeroPagina = boton.getAttribute('data-mpv-resenas-pagina');
          mostrarPaginaResenas(numeroPagina);
          var seccionResenas = contenedor.querySelector('.mpv-resenas-seccion');
          if (seccionResenas) {
            seccionResenas.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });
    }

    var contenedorRecomendados = contenedor.querySelector('.mpv-recomendados');
    if (contenedorRecomendados) {
      contenedorRecomendados.addEventListener('click', function (evento) {
        var flechaAnterior = evento.target.closest('[data-mpv-recomendados-anterior]');
        var flechaSiguiente = evento.target.closest('[data-mpv-recomendados-siguiente]');
        var botonFavorito = evento.target.closest('[data-mpv-favorito]');
        var botonAgregarRecomendado = evento.target.closest('[data-mpv-recomendado-agregar]');

        if (flechaAnterior || flechaSiguiente) {
          var lista = contenedorRecomendados.querySelector('[data-mpv-recomendados-lista]');
          if (!lista) {
            return;
          }
          var primeraTarjeta = lista.querySelector('.mpv-recomendado-tarjeta');
          var ancho = primeraTarjeta ? primeraTarjeta.offsetWidth + 12 : 240;
          lista.scrollBy({ left: flechaAnterior ? -ancho : ancho, behavior: 'smooth' });
          return;
        }

        if (botonFavorito) {
          var activo = botonFavorito.getAttribute('data-activo') === 'true';
          botonFavorito.setAttribute('data-activo', activo ? 'false' : 'true');
          return;
        }

        if (botonAgregarRecomendado) {
          if (botonAgregarRecomendado.disabled) {
            return;
          }
          var variantId = botonAgregarRecomendado.getAttribute('data-variant-id');
          if (!variantId) {
            return;
          }
          var textoOriginalRecomendado = botonAgregarRecomendado.textContent;
          botonAgregarRecomendado.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          })
            .then(function (respuesta) {
              if (!respuesta.ok) {
                throw new Error('No se pudo agregar al carrito');
              }
              botonAgregarRecomendado.textContent = '✓';
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              try {
                var cajonCarrito = document.querySelector('cart-drawer');
                if (cajonCarrito && typeof cajonCarrito.open === 'function') {
                  cajonCarrito.open();
                }
              } catch (error) {
                // El tema no tiene cajón de carrito; se omite silenciosamente.
              }
              setTimeout(function () {
                botonAgregarRecomendado.textContent = textoOriginalRecomendado;
                botonAgregarRecomendado.disabled = false;
              }, 1800);
            })
            .catch(function () {
              botonAgregarRecomendado.textContent = textoOriginalRecomendado;
              botonAgregarRecomendado.disabled = false;
            });
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mpvInit);
  } else {
    mpvInit();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
